import React from 'react';
import { Select, Input, Button, Icon, Tooltip, Popconfirm, Popover, Switch, message } from 'antd';
import EditRole from './EditRole';
import { Row, Col } from 'reactstrap';
import HandleRole from '../Wizard/HandleRole';
import HandleAddress from '../Wizard/HandleAddress'
import SERVER_URL from '../Global';
import Geosuggest from 'react-geosuggest';

const { Option } = Select;

class EditOff extends React.Component {
    constructor(props) {
        super(props);

        let contatti = []
        let offName = null
        let notes = null
        let offCreated = false
        let hroId = ''
        let officeId = ''
        let contactsOffice = []
        let contactId = -1
        let roles = []
        let contactsHr = []
        let contactHrId = 0
        let vari = []
        let offPrincipal = false
        let indirizzi = []
        let addressCreated = false
        let roleOrderList = []
        let roleOrderList2 = []
        let newRoleId = 0

        if (this.props.data != null) {
            this.props.data.brHrRoleOfficies.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map((br, i) => {
                br.brHrRoleOfficeContacts.map(brCon => {
                    brCon.sort = brCon.contact.sort
                })

                if (br.roleId === null) {
                    br.brHrRoleOfficeContacts.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map((con, i) => {
                        contatti.push({ text: con.contact.text, id: i, remove: false, contactId: con.contact.contactId, propId: con.contact.property_TrValue })
                        contactsOffice.push(i)
                        contactId = i
                    })
                    hroId = br.hroId
                    officeId = br.officeId
                }
                else {
                    if (vari.indexOf(br.roleId) == -1) {
                        vari.push(br.roleId)
                        contactHrId++
                        roleOrderList.push({ id: newRoleId, order: br.role.sort, deleted: false })
                        newRoleId++
                    }
                }
            })

            this.props.data.addresses.map((ad, i) => {
                indirizzi.push({ addressId: ad.addressId, id: i, zipCodeId: ad.zipCodeId, cityId: ad.cityId, zipCodeValue: ad.zipCode.value, cityName: ad.city.name, provinceName: ad.city.province.name, regionName: ad.city.province.region.name, streetName: ad.street })
            })

            if (indirizzi.length == 0) {
                indirizzi = [{ addressId: null, id: null, zipCodeId: null, cityId: null, zipCodeValue: null, cityName: null, provinceName: null, regionName: null, streetName: null }]
            }
            
            contactsHr.push(contactHrId)
            roleOrderList.push({ id: newRoleId, order: newRoleId + 1, deleted: false })
            newRoleId++
            offName = this.props.data.name
            if (this.props.data.notes !== 'null' && this.props.data.notes !== null && this.props.data.notes !== '') {
                notes = this.props.data.notes
            }
            offCreated = true
            offPrincipal = this.props.data.isPrincipal
            //ordino la lista dei ruoli per ordinamento scelto e poi per id
            roleOrderList.sort(function (a, b) {
                return a.order - b.order;
            })
            roleOrderList.map((el, i) => {
                el.order = i + 1;
            })
            roleOrderList.sort(function (a, b) {
                return a.id - b.id;
            })
        }

        this.state = {
            roleList: vari,
            user: this.props.user,
            loading: false,
            roles: roles,
            offCreated: offCreated,
            offSaved: offCreated,
            officeId: officeId,
            offName: offName,
            notes: notes,
            properties: this.props.properties,
            contactsOffice: contactsOffice,
            contactsHr: contactsHr,
            contactId: contactId,
            contactHrId: contactHrId,
            offId: 0,
            companyId: this.props.companyId,
            officeContactText: '',
            propId: 3,
            contactModified: false,
            isPrincipal: offPrincipal,
            i: this.props.i,
            location: [],
            locationAdded: false,
            emailContactAlert: false,
            inputOnFocus: '',
            contacts: contatti,
            hroId: hroId,
            officeDeleted: false,
            mandatoryOfficeName: true,
            roleSaved: true,
            addressCreated: addressCreated,
            addresses: indirizzi,
            addressBox: false,
            officeIndex: this.props.idOffice,
            roleUpdatedOrder: true,
            newRoleId: newRoleId,
            roleOrderList: roleOrderList,
            deletedRole: 0,
            roleHasToBeShown: true,
            contactValidator: true,
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        this.saveOffice = this.saveOffice.bind(this);
        this.handleProp = this.handleProp.bind(this);
        this.handleContactText = this.handleContactText.bind(this);
        this.addContact = this.addContact.bind(this);
        this.addNewRole = this.addNewRole.bind(this);
        this.checkPrincipal = this.checkPrincipal.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.saveContacts = this.saveContacts.bind(this);
        this.handleCity = this.handleCity.bind(this);
        this.addInput = this.addInput.bind(this);
        this.removeContact = this.removeContact.bind(this);
        this.orderUp = this.orderUp.bind(this);
        this.orderDown = this.orderDown.bind(this);
        this.deleteOffice = this.deleteOffice.bind(this);
        this.callbackRoleSaved = this.callbackRoleSaved.bind(this)
        this.handleZipCode = this.handleZipCode.bind(this);
        this.handleCityId = this.handleCityId.bind(this);
        this.addNewAddress = this.addNewAddress.bind(this);
        this.counterDeletedRole = this.counterDeletedRole.bind(this);
        this.showOrderButtons = this.showOrderButtons.bind(this);

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.i !== prevProps.i) {
            this.setState({ i: this.props.i });
        } else if (this.props.idOffice !== prevProps.idOffice) {
            this.setState({ officeIndex: this.props.idOffice }, this.saveOffice)
        }
    }

    handleNameChange(event) {
        this.setState({ offName: event.target.value, mandatoryOfficeName: true, offSaved: false });
        if (event.target.value.length === 0) {
            this.setState({ mandatoryOfficeName: false, offSaved: true, offName: null })
        }
    }

    handleNotesChange(event) {
        this.setState({ notes: event.target.value, offSaved: false });
        if (event.target.value.length === 0 && this.state.offCreated === false) {
            this.setState({ notes: null, offSaved: true })
        }
    }

    saveOffice() {
        this.setState({ loading: true })
        if (this.state.offCreated) {

            fetch(`${SERVER_URL + 'api/Office'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': `${this.state.offName}`,
                    'notes': this.state.notes,
                    'officeid': `${this.state.officeId}`,
                    'companyId': `${this.state.companyId}`,
                    "isPrincipal": this.state.isPrincipal,
                    "city": `${this.state.city}`,
                    "Status": this.props.status,
                    'Sort': this.state.officeIndex
                })
            }).then(
                this.setState({ loading: false, offSaved: true }),
                this.saveAddress(),
                //salva contatti
                this.saveContacts()
            )
        }
        else {
            //crea office
            fetch(
                `${SERVER_URL + "api/office"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': `${this.state.offName}`,
                        'companyId': `${this.state.companyId}`,
                        "isPrincipal": this.state.isPrincipal,
                        "city": `${this.state.city}`,
                        'Sort': this.state.officeIndex,
                        "Status": this.props.status,
                        "notes": this.state.notes
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ offCreated: true, officeId: res.data, loading: false, offSaved: true, officeDeleted: false }, () => {
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                },
                                body: JSON.stringify({
                                    'officeId': `${this.state.officeId}`,
                                    "Status": this.props.status,
                                    'sort': this.props.idOffice
                                })
                            }
                        ).then(response => response.json())
                            .then(res => {
                                this.setState({ hroId: res.data }),

                                    //salva contatti
                                    this.saveContacts()
                            }
                            )
                    })
                }
                );
        }
        this.setState({ contactModified: false })
    }

    saveContacts() {
        this.state.contacts.map(con => {
            if (!con.remove && con.contactId === '') {
                fetch(
                    `${SERVER_URL + "api/contact"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'text': `${con.text}`,
                            'Property_TrValue': `${con.propId}`
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        this.state.contacts[con.id].contactId = res.data

                        //colleghiamo il contatto alla role office
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact"}`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                },
                                body: JSON.stringify({
                                    'hroId': this.state.hroId,
                                    'contactId': res.data,
                                    'isCollaboration': false,
                                    "Status": 1,
                                    'sort': con.id
                                })
                            })
                        // fine fetch
                    }
                    )
            }
            else if (!con.remove && con.contactId !== '') {
                fetch(`${SERVER_URL + 'api/contact'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'text': `${con.text}`,
                        'Property_TrValue': `${con.propId}`,
                        'contactid': con.contactId
                    })
                }).then(response => response.json())
                    .then(res => {
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOfficeContact/"}`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                },
                                body: JSON.stringify({
                                    'hroId': this.state.hroId,
                                    'contactId': res.data,
                                    'isCollaboration': false,
                                    "Status": 1,
                                    'sort': con.id
                                })
                            })
                    })
            }
            else if (con.remove && con.contactId !== '') {

                //scolleghiamo il contatto dalla role office
                fetch(
                    `${SERVER_URL + "api/brHrRoleOfficeContact/" + this.state.hroId + "/" + con.contactId}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        }
                    }).then(response => response.json())
                    .then(res => {
                        this.state.contacts[con.id].contactCreated = false

                        if (!con.isCollaboration) {
                            fetch(`${SERVER_URL + `api/contact/hard/${con.contactId}`}`, {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                }
                            }).then(response => response.json())
                                .then(res => {
                                    if (!res.ok) {
                                        message.warning("The contact is shared by other companies, it has not been deleted")
                                    }
                                })
                        }
                    })
                //fine fetch
            }
        })
    }

    deleteOffice() {
        if (this.state.offCreated) {

            this.props.deleteOffice(this.state.officeId, this.props.id);
        }
    }

    //inizio contatti
    handleProp(value, i) {
        let emailValidator = true
        let urlValidator = true
        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: '', id: i, remove: false, contactId: '', propId: value })
        } else {
            this.state.contacts[i].propId = value
            if ((value == 5 || value == 23) && !this.state.contacts[i].text.includes('@')) {
                document.getElementById("emailHasAt" + i + this.state.officeId).style.display = 'block'
                emailValidator = false
            }
            else {
                document.getElementById("emailHasAt" + i + this.state.officeId).style.display = 'none'
                emailValidator = true
            }
            if (value == 4 && !this.state.contacts[i].text.includes('http')) {
                document.getElementById("urlHasHttp" + i + this.state.officeId).style.display = 'block'
                urlValidator = false
            } else {
                document.getElementById("urlHasHttp" + i + this.state.officeId).style.display = 'none'
                urlValidator = true
            }
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactModified: true, offSaved: false, contactValidator: contactValidator })
    }

    handleContactText(event, i) {
        var field = "contactText" + i
        if (event.target.value.length > 0) {

            var contacts = this.state.contacts

            contacts[i].text = event.target.value

            this.setState({ [field]: event.target.value, contactModified: true, offSaved: false, contacts: contacts });
        } else if (event.target.value.length === 0) {
            var contacts = this.state.contacts

            contacts[i].text = null
            this.setState({ contactModified: false, contacts: contacts });
        }
    }

    addContact(i) {
        let emailValidator = true
        let urlValidator = true
        var field = "contactText" + i
        var text = this.state[field]

        if (!this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts.push({ text: text, id: i, remove: false, contactId: '', propId: 3 })
        } else {
            if (text === undefined) {
                this.setState({
                    [field]: this.state.contacts[i].text
                })
            }
            else {
                this.state.contacts[i].text = text
                if ((this.state.contacts[i].propId === 5 || this.state.contacts[i].propId === 23) && !text.includes('@')) {
                    document.getElementById("emailHasAt" + i + this.state.officeId).style.display = 'block'
                    emailValidator = false
                }
                else {
                    document.getElementById("emailHasAt" + i + this.state.officeId).style.display = 'none'
                    emailValidator = true
                }
                if (this.state.contacts[i].propId === 4 && !text.includes('http')) {
                    document.getElementById("urlHasHttp" + i + this.state.officeId).style.display = 'block'
                    urlValidator = false
                }
                else {
                    document.getElementById("urlHasHttp" + i + this.state.officeId).style.display = 'none'
                    urlValidator = true
                }
            }
        }
        let contactValidator = emailValidator && urlValidator ? true : false
        this.setState({ contactValidator: contactValidator });
    }

    addInput(i) {
        if (i >= this.state.contactId) {
            var id = this.state.contactId + 1

            this.setState({ contactId: id })

            this.state.contactsOffice.push(id)

            this.state.contacts.push({ text: '', id: id, remove: false, contactId: '', propId: 3 })
        }
    }

    removeContact(i) {
        if (this.state.contacts.hasOwnProperty(i)) {
            this.state.contacts[i].remove = true
        }

        this.setState({ offSaved: false })

        document.getElementById('contact' + i + this.state.officeId).remove()
    }

    //fine contatti

    handleCity(event) {
        this.setState({ city: event.target.value });
        if (event.target.value.length === 0 && this.state.offCreated === false) {
            this.setState({ city: null, offSaved: true })
        }
    }


    addNewRole() {
        var id = this.state.contactHrId + 1;
        var newId = this.state.newRoleId

        this.state.roleOrderList.push({ id: newId, order: newId + 1, deleted: false })
        let lunghezza = this.state.roleOrderList.length
        let lastElementId = parseInt(lunghezza) - 1

        if (this.state.deletedRole > 0) {

            let newOrderList = this.state.roleOrderList;
            newOrderList[lastElementId].order = parseInt(newOrderList[lastElementId].order) - parseInt(this.state.deletedRole);
            newOrderList.map(el => {
                if (el.deleted == true) {
                    el.order = -1;
                }
            })
            this.setState({ roleOrderList: newOrderList })

        }

        this.setState({ contactHrId: id, roleSaved: false, newRoleId: this.state.newRoleId + 1 })
        this.state.contactsHr.push(`${id}`)
    }

    checkPrincipal(checked) {
        this.setState({ isPrincipal: checked, offSaved: false, mandatoryOfficeName: false })

        if (checked) {
            this.setState({ mandatoryOfficeName: true })
        }
        this.props.principalOk(checked)
    }

    counterDeletedRole = (childData) => {
        let roleDeleted = parseInt(this.state.deletedRole)
        let counter = roleDeleted + childData;
        this.setState({ deletedRole: counter })
    }

    showOrderButtons = (roleData, num) => {
        let roleOrder = this.state.roleOrderList
        roleOrder[num].deleted = true;
        roleOrder.map(el => {
            if (el.order > roleOrder[num].order) {
                el.order = el.order - 1
            }
        })
        roleOrder[num].order = -1;
        this.setState({ roleHasToBeShown: roleData, roleOrderList: roleOrder })
    }

    orderDown(index) {
        if (this.state.roleOrderList[index].order !== 1) {
            let newOrderList = this.state.roleOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.roleOrderList[index].order - 1);
            if (indexOrder != -1) {
                newOrderList[index].order = this.state.roleOrderList[index].order - 1;
                newOrderList[indexOrder].order = this.state.roleOrderList[indexOrder].order + 1;
                this.setState({ roleOrderList: newOrderList })
            }
        }
    }

    orderUp(index) {
        if (this.state.roleOrderList.length > this.state.roleOrderList[index].order) {
            let newOrderList = this.state.roleOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.roleOrderList[index].order + 1);
            if (indexOrder != -1) {
                newOrderList[index].order = this.state.roleOrderList[index].order + 1;
                newOrderList[indexOrder].order = this.state.roleOrderList[indexOrder].order - 1;
                this.setState({ roleOrderList: newOrderList })
            }
        }
    }

    callbackRoleSaved = (childData) => {
        this.setState({ roleSaved: childData })
    }

    handleStreetNameChange = (childData, id) => {
        let indirizzi = this.state.addresses
        indirizzi[id].streetName = childData
        this.setState({ offSaved: false, addresses: indirizzi });
    }

    handleZipCode = (childData, id) => {
        let indirizzi = this.state.addresses
        indirizzi[id].zipCodeId = childData
        this.setState({ offSaved: false, addresses: indirizzi });
    }

    handleCityId = (childData, id) => {
        let indirizzi = this.state.addresses
        indirizzi[id].cityId = childData
        this.setState({ offSaved: false, addresses: indirizzi });
    }

    addNewAddress() {
        let indirizzi = this.state.addresses
        indirizzi.push({ addressId: null, id: this.state.addresses.length, zipCodeId: null, cityId: null, zipCodeValue: null, cityName: null, provinceName: null, regionName: null, streetName: null })
        this.setState({ addresses: indirizzi })
    }

    saveAddress() {

        this.state.addresses.map((ad, i) => {
            let streetName = ' '
            if (ad.streetName != null) {
                streetName = ad.streetName
            }

            if (ad.addressId == null && ad.cityId != null) { // sto crendo l'address

                fetch(
                    `${SERVER_URL + "api/Address"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'Street': streetName,
                            'OfficeId': this.state.officeId,
                            'CityId': ad.cityId,
                            'ZipCodeId': ad.zipCodeId
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        let addresses = this.state.addresses
                        addresses[i].addressId = res.data

                        this.setState({ addressCreated: true, addresses: addresses })
                    })
            } else if (ad.addressId != null && ad.cityId != null) { //sto aggiornado l'address
                fetch(
                    `${SERVER_URL + "api/Address"}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            'Street': streetName,
                            'OfficeId': this.state.officeId,
                            'CityId': ad.cityId,
                            'ZipCodeId': ad.zipCodeId,
                            'AddressId': ad.addressId,
                        })
                    }
                ).then(response => response.json())
                    .then(res => {
                        this.setState({ addressCreated: true })
                    })
            } else if (ad.cityId == null && ad.addressId != null) {
                fetch(
                    `${SERVER_URL + "api/Address/hard/" + ad.addressId}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        }
                    })
            }

        })

    }

    render() {

        const selectBeforeProp = (i) => {
            let value = ''
            try {
                var propInd = this.state.properties.findIndex(obj => obj.value == this.state.contacts[i].propId)

                value = this.state.properties[propInd].text
            } catch (e) {
                message.error("Error loading contacts: " + e.message, 5);
            }

            return (
                <Select onChange={(value) => this.handleProp(value, i)} defaultValue={value} style={{ width: 90 }}>
                    {this.state.properties.map(prop => {
                        if (prop.value != 6) { //returna i non address
                            return <Option key={prop.text} value={prop.value}>{prop.text}</Option>
                        }
                    })
                    }
                </Select>
            )
        };
        let addRoleButton = this.state.roleSaved ?
            <div style={{ marginLeft: '35px' }}>
                < Button onClick={this.addNewRole} className="createRoleButton" icon="plus"></Button>
            </div>
            :
            <div style={{ marginLeft: '35px' }}>
                < Button disabled onClick={this.addNewRole} className="createRoleButton" icon="plus"></Button>
            </div>

        let roleBoxActive = this.state.offCreated ?
            <div>
                <ul style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    {
                        this.state.roleList.map((roleId, i) => {
                            var num = parseInt(i, 10);
                            let x = parseInt(i) + 1;
                            var index = this.state.roleOrderList.findIndex(obj => obj.id == i);
                            let officeId = this.state.officeId;
                            let roleNotDeleted = !this.state.roleOrderList[num].deleted ?

                                <div>
                                    <div className="orderArrows">
                                        {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                                        <br />
                                        <div className="hrOrderNumber">{this.state.roleOrderList[index].order}</div>
                                        <br />
                                        {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                                    </div>
                                    <EditRole i={num} order={this.state.roleOrderList[index].order} showOrderButtons={this.showOrderButtons} parentCounterDeletedRole={this.counterDeletedRole} roleUpdatedOrder={this.state.roleUpdatedOrder} parentCallbackRoleSaved={this.callbackRoleSaved} data={this.props.data} roleId={roleId} status={this.props.status} user={this.state.user} properties={this.state.properties} office={officeId} />
                                </div> : ""
                            return (
                                <li key={x} style={{ order: this.state.roleOrderList[index].order, listStyle: "none" }}>
                                    {roleNotDeleted}
                                </li>
                            )
                        })
                    }
                    {
                        this.state.contactsHr.map(i => {
                            var num = parseInt(i, 10);
                            let x = parseInt(i) + 1;
                            var index = this.state.roleOrderList.findIndex(obj => obj.id == i);
                            let officeId = this.state.officeId;
                            let roleNotDeleted = !this.state.roleOrderList[num].deleted ?

                                <div>
                                    <div className="orderArrows">
                                        {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                                        <br />
                                        <div className="hrOrderNumber">{this.state.roleOrderList[index].order}</div>
                                        <br />
                                        {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                                    </div>
                                    <HandleRole order={this.state.roleOrderList[index].order} showOrderButtons={this.showOrderButtons} parentCounterDeletedRole={this.counterDeletedRole} roleUpdatedOrder={this.state.roleUpdatedOrder} i={num} parentCallbackRoleSaved={this.callbackRoleSaved} data={x} status={this.props.status} user={this.state.user} properties={this.state.properties} office={this.state.officeId} />
                                </div> : ""
                            return (
                                <li key={x} style={{ order: this.state.roleOrderList[index].order, listStyle: "none" }}>
                                    {roleNotDeleted}
                                </li>
                            )
                        })
                    }
                </ul>
                {addRoleButton}
            </div> : ""

        let mainOfficeName = this.state.isPrincipal ?
            <Input autoComplete="new-password" className={"baseInput" + " name" + this.props.i + " companyNameWizard"} style={{ width: '100%' }} disabled value={"Office Name"} placeholder="Office Name" allowClear={true} onChange={this.handleNameChange} />
            :
            <Input autoComplete="new-password" className={"baseInput" + " name" + this.props.i + " companyNameWizard"} style={{ width: '100%' }} value={this.state.offName} placeholder="Office Name" allowClear={true} onChange={this.handleNameChange} />

        let mandatoryName = this.state.mandatoryOfficeName || this.state.isPrincipal ? <Icon type="check-circle" style={{ left: '0px', marginLeft: '10px' }} /> : <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip>

        let mainOffice = this.props.idOffice == 1 ?
            <div style={{ width: '100%', display: 'inline-flex' }}>
                <div style={{ width: '18%' }}>
                    <Tooltip placement="topLeft" title='Switch to create company’s main contacts'>
                        <h4 style={{ marginTop: '0px' }}><Icon type="info-circle" /> Main Office</h4>
                    </Tooltip>
                    <Switch className="isPrincipalCheck" checked={this.state.isPrincipal} onChange={this.checkPrincipal} />
                </div>
                <div style={{ width: '78%', marginLeft: '4%' }}>
                    <Tooltip placement="topLeft" title="Insert the Office name here">
                        <h4 style={{ marginTop: '0px' }}><Icon type="info-circle" /> Office Name</h4>
                    </Tooltip>
                    <div className="wizardCompName">
                        {mainOfficeName}
                        {mandatoryName}
                    </div>
                </div>
            </div>
            :
            <div style={{ width: '100%' }}>
                <div style={{ width: 'calc(100% - 7px)' }}>
                    <Tooltip placement="topLeft" title="Insert the Office name here">
                        <h4 style={{ marginTop: '0px' }}><Icon type="info-circle" /> Office Name</h4>
                    </Tooltip>
                    <div className="wizardCompName">
                        {mainOfficeName}
                        {mandatoryName}
                    </div>
                </div>
            </div>

        let mandatoryAreNotMet = !this.state.mandatoryOfficeName ? <p><Icon type="exclamation-circle" style={{ color: 'red' }} /> Office Name field is empty</p> : this.state.offSaved ? <p>Everything is already saved</p> : !this.state.contactValidator ? <p>One ore more contacts are not validated</p> : ""

        let officeSave = !this.state.mandatoryOfficeName || !this.state.contactValidator ? <Popover content={mandatoryAreNotMet}><Button disabled onClick={this.saveOffice} className="saveButtonHrWizard" icon="save">Save Office</Button></Popover> : this.state.offSaved ? <Popover content={mandatoryAreNotMet}><Button disabled onClick={this.saveOffice} className="saveButtonHrWizard" icon="save">Save Office</Button></Popover> : <Button onClick={this.saveOffice} className="saveButtonHrWizard" icon="save">Save Office</Button>

        let officeDelete = this.state.offCreated ? <Popconfirm placement="top" title="Are you sure you want to delete this Office?" onConfirm={this.deleteOffice} okText="Yes" cancelText="No"> <Button className="deleteButtonHrWizard"><Icon type="close" /> Delete Office</Button></Popconfirm> : <Button disabled className="deleteButtonHrWizard"><Icon type="close" /> Delete Office</Button>

        let location = this.state.locationAdded ?
            <div className="officePosition">
                <p className="address"><b>Address: </b>{this.state.address}  <a target="_blank" href={this.state.url}><Icon className="goToMap" type="environment" theme="twoTone" /></a></p>
                <p className="address"><b>Website: </b>{this.state.location.gmaps.website} </p>
                <p className="address"><b>Phone Number: </b>{this.state.location.gmaps.international_phone_number} </p>
            </div>
            : <Geosuggest country="it" maxPriceLevel="0" onSuggestSelect={this.echoAddres} placeholder="Address" />

        let mapAddresses =
            <div className="addressesBox">
                {this.state.addresses.map(ad => {
                    if (ad.id != null) {
                        let result = ad.zipCodeValue != null && ad.cityName != null && ad.provinceName != null && ad.regionName != null ? `${ad.zipCodeValue}, ${ad.cityName} (${ad.provinceName}) ${ad.regionName}` : null
                        return (
                            <div key={ad.id} className="handleAddressBOX">
                                <HandleAddress index={ad.id} streetName={ad.streetName} addressResult={result} user={this.state.user} parentCallback={this.handleStreetNameChange} parentCallbackZip={this.handleZipCode} parentCallbackCity={this.handleCityId} />
                            </div>
                        )
                    } else {
                        return (
                            <div key={ad.id} className="handleAddressBOX">
                                <HandleAddress user={this.state.user} parentCallback={this.handleStreetNameChange} parentCallbackZip={this.handleZipCode} parentCallbackCity={this.handleCityId} />
                            </div>
                        )
                    }
                })
                }
            </div>

        let newAddress = < Button style={{ marginBottom: '0px' }} onClick={this.addNewAddress} className="createContactButton" icon="plus"></Button>

        let moveUp = this.props.idOffice > 1 && !this.props.isThereAPrincipal ? <Popover content={<span>Move Up</span>}><Icon type="up" onClick={() => this.props.moveOffice(this.props.id, this.props.idOffice, true)} /></Popover> : this.props.idOffice > 2 ? <Popover content={<span>Move Up</span>}><Icon type="up" onClick={() => this.props.moveOffice(this.props.id, this.props.idOffice, true)} /></Popover> : ''

        let moveDown = this.props.offLength > this.props.idOffice ? <Popover content={<span>Move Down</span>}><Icon type="down" onClick={() => this.props.moveOffice(this.props.id, this.props.idOffice, false)} /></Popover> : ''

        let move = !this.state.isPrincipal && this.props.everyOffCreated ? <div className="moveIcon">
            {moveUp}
            {moveDown}
        </div> : !this.state.isPrincipal && !this.props.everyOffCreated ?
                <Tooltip title="There is one office not created">
                    <div className="moveIcon">
                        {moveUp}
                        {moveDown}
                    </div>
                </Tooltip> : ''

        return (
            <Col className="wizardFields wizardCompany officeBox" sm="12" style={{ order: this.props.idOffice }}>

                <Row>
                    <Col sm='6' className="officeDetails">
                        <h6>Office details</h6>
                        {move}
                    </Col>
                    <Col sm='6'>
                        <h6 className={"roleHrDetailsTitle" + this.state.offCreated} style={{ paddingLeft: '50px' }}>Role and Hr details</h6>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ backgroundColor: '#fff', margin: '15px' }} className={"officeDeleted" + this.state.officeDeleted + " " + "Office" + this.props.i + " " + this.state.offCreated + "officeBox" + this.state.offSaved}>
                        <Row>
                            <Col className="wizardCompanyCreation" sm="12">
                                {mainOffice}
                                {mapAddresses}
                                {newAddress}
                            </Col>

                            <Col sm="12">

                                <div className="wizardParagraph">
                                    <Tooltip placement="topLeft" title="Add phone number, website, email, address, Fax, social media links">
                                        <h4><Icon type="info-circle" /> Contacts</h4>
                                    </Tooltip>

                                    {this.state.contactsOffice.map(i => {
                                        let text = ''
                                        if (this.state.contacts.hasOwnProperty(i)) {
                                            text = this.state.contacts[i].text
                                        }


                                        return (
                                            <div className="wizardOfficeContacts" key={i}>
                                                <div className="wizardInputsNew" id={'contact' + i + this.state.officeId} style={{ display: 'block' }}>
                                                    <div style={{ width: '100%', display: 'flex' }}>
                                                        <div style={{ width: '100%' }} className="wizardSelectNew" >
                                                            <Input autoComplete="new-password" value={text} onPressEnter={() => this.addInput(i)} onBlur={() => this.addContact(i)} className={"anticonNoTop modified" + this.state.contactModified} onChange={(e) => this.handleContactText(e, i)} style={{ width: 'calc(100% - 34px)', height: 'auto' }} addonBefore={selectBeforeProp(i)} placeholder="Insert text" />
                                                        </div>
                                                        <Popconfirm title="Are you sure delete this contact?" okText="Yes" cancelText="No" onConfirm={() => this.removeContact(i)} ><Icon className={"anticon-save deleteDisplay" + this.state.contacts.hasOwnProperty(i)} type="close" /></Popconfirm>
                                                    </div>
                                                    <p style={{ display: 'none' }} className="emailHasAt" id={"emailHasAt" + i + this.state.officeId}> Warning! "@" is missing</p>
                                                    <p style={{ display: 'none' }} className="emailHasAt" id={"urlHasHttp" + i + this.state.officeId}> Warning! "http:// or https://" is missing</p>
                                                </div>
                                            </div>
                                        )
                                    })
                                    }
                                    <Button onClick={() => this.addInput(this.state.contactId)} className="createContactButton" icon="plus"></Button>
                                </div>
                            </Col>
                            <div className="buttonsSaveOffice">
                                {officeSave}
                                {officeDelete}
                            </div>
                        </Row>
                    </Col>
                    <Col style={{ margin: '15px' }} className="roleBoxes">
                        {roleBoxActive}
                    </Col>
                </Row>
            </Col>
        );
    }
}

export default EditOff;


// WEBPACK FOOTER //
// ./src/EditWizard/EditOff.js